import { Model } from "./base/model";
export class AppData extends Model {
    constructor() {
        super(...arguments);
        this.basket = [];
        this.order = {
            payment: 'online',
            address: '',
            email: '',
            phone: '',
            total: 0,
            items: []
        };
        this.formErrors = {};
    }
    setPreview(item) {
        this.preview = item.id;
        this.emitChanges('preview:changed', item);
    }
    setItems(items) {
        this.catalog = items;
        this.emitChanges('items:changed', { catalog: this.catalog });
    }
    addItem(item) {
        if (!this.basket.includes(item)) {
            this.basket.push(item);
            this.updateBasket();
        }
    }
    removeItem(item) {
        this.basket = this.basket.filter((itm) => itm.id != item.id);
        this.updateBasket();
    }
    updateBasket() {
        this.emitChanges('basket:changed', this.basket);
        this.emitChanges('counter:changed', this.basket);
    }
    cleanBasket() {
        this.basket = [];
        this.updateBasket();
    }
    cleanOrder() {
        this.order = {
            payment: '',
            address: '',
            email: '',
            phone: '',
            total: 0,
            items: []
        };
    }
    setShipping(field, value) {
        this.order[field] = value;
        if (this.validationShipping()) {
            this.events.emit('shipping:ok', this.order);
        }
    }
    setContacts(field, value) {
        this.order[field] = value;
        if (this.validationContacts()) {
            this.events.emit('contacts:ok', this.order);
        }
    }
    getTotal() {
        return this.basket.reduce((total, item) => total + item.price, 0);
    }
    validationContacts() {
        const errors = {};
        if (!this.order.email) {
            errors.email = 'Заполните поле Email';
        }
        if (!this.order.phone) {
            errors.phone = 'Заполните поле Телефон';
        }
        this.formErrors = errors;
        this.events.emit('formErrors:change', this.formErrors);
        return Object.keys(errors).length === 0;
    }
    validationShipping() {
        const errors = {};
        if (!this.order.address) {
            errors.address = 'Заполните поле Адрес';
        }
        this.formErrors = errors;
        this.events.emit('formErrors:change', this.formErrors);
        return Object.keys(errors).length === 0;
    }
}
